// extracted by mini-css-extract-plugin
export default {"container":"SmallDropdown_container__zW9Bh"};